import { useInView } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

import { MUTED_GRAY } from '../constants';

export interface AnimatedStatProps {
  value: number;
  suffix?: string;
  color: string;
  label: string;
}

export function AnimatedStat({ value, suffix = '', color, label }: AnimatedStatProps) {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true });
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    let frame: number;
    const start = performance.now();
    const duration = 1500;
    const runAnimation = (now: number) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - (1 - progress) ** 3;
      setCurrent(Math.round(value * eased));
      if (progress < 1) frame = requestAnimationFrame(runAnimation);
    };
    frame = requestAnimationFrame(runAnimation);
    return () => cancelAnimationFrame(frame);
  }, [inView, value]);

  return (
    <div ref={ref} className='text-center'>
      <p className='text-3xl font-bold md:text-5xl' style={{ color, fontFamily: 'var(--font-bai)' }}>
        {current}
        {suffix}
      </p>
      <p className='mt-1 text-sm' style={{ color: MUTED_GRAY, fontFamily: 'var(--font-outfit)' }}>
        {label}
      </p>
    </div>
  );
}
